import { render } from "./EventEdit-View.vue?vue&type=template&id=139178ce"
import script from "./EventEdit-View.vue?vue&type=script&lang=js"
export * from "./EventEdit-View.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__